import {
  createRouter,
  createWebHistory,
  // createWebHashHistory,
} from 'vue-router'
import routes from './modules/index'
import constantRoutes from './constant-routes'
import { useUserStore } from '@/store/modules/user'
export const allRoutes = constantRoutes.concat(routes)
export const authRoutes = routes
export const fixRoutes = constantRoutes
const router = createRouter({
  // 采用 history 模式
  history: createWebHistory('/'), //TODO: createWebHashHistory('/')
  routes: allRoutes,
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  if (!to.meta.noCheck && !userStore.hasLogged && to.path !== '/login') {
    //需要登录，检查是否已登录
    next({ path: '/login' })
  } else {
    next()
  }
})

export default router
